/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { object } from 'prop-types';
import { Query } from '@apollo/client/react/components';

import mbpLogger from '@module-logger/mbp';

import WineDisclaimer from './WineDisclaimer';
import { GRAPHQL_ENV } from '../../../../../gql';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import findContent from '../../../../../gql/queries/findContent';

const GraphqlWineContainer = ({
    brand,
}) => {
    const findContentOptions = {
        brand: brand['domain-name'],
        contentType: 'marketing_spots',
        query: '\\"title\\" : \\"Wine Disclaimer Details\\"',
    };
    const WINE_DISCLAIMER_QUERY = findContent(findContentOptions);

    return (
        <Query query={WINE_DISCLAIMER_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: WINE_DISCLAIMER_QUERY,
                        component: 'GraphqlWineContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: WINE_DISCLAIMER_QUERY,
                        component: 'GraphqlWineContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                const { content } = data.findContent;
                if (!content) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: WINE_DISCLAIMER_QUERY,
                        component: 'GraphqlWineContainer.js',
                        message: 'No content returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                return (
                    <WineDisclaimer brand={brand} data={data} />
                );
            }}
        </Query>
    );
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

GraphqlWineContainer.propTypes = {
    brand: object.isRequired,
};

export default connect(
    mapStateToProps,
    null,
)(GraphqlWineContainer);
